import { createContext, useContext } from 'react';
import { AppContextReducerType } from '../../interfaceTypes';
import { initialState } from '../../reducer/AppContextReducer';

export const AppContext = createContext<AppContextReducerType>({
  ...initialState,
  setIsAppUserLoggedIn: () => { },
  setCurrentUser: () => { },
  dispatch: () => {
    return;
  }
});

export const useAppContext = () => useContext(AppContext);